import { formRules } from "../../../../../config/validations/formRules";
import { validations } from "../../../../../config/validations/validations";

export const rules: any = {
    name: () => formRules.name(),
    last_name: () => formRules.last_name(),
    email: (field?: string) => [
      validations.required.text(field),
      validations.email(field),
    ],
    mobileNumber: () => formRules.mobileNumber(),
    roleId: (field?: string) => [validations.required.select(field)],
    password: (field?: any) => [
      validations.required.text(field),
      validations.pattern.password(field),
      validations.min.text(8),
      validations.max.text(50),
    ],
    companyInitials: (field?: string) => [
        validations.required.text(field),
        validations.pattern.specialChar(),
        validations.pattern.numericValuesNotAllow(),
        validations.min.text(3),
        validations.max.text(3)
    ],
    startDate: (field?: string) => [validations.required.text(field)],
    endDate: (field?: string) => [validations.required.text(field)],
};
